/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoVkIcon24Solid = forwardRef('LogoVkIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12.68 17.998c-6.568 0-10.315-4.503-10.471-11.997h3.29c.109 5.5 2.534 7.83 4.456 8.31v-8.31h3.098v4.744c1.898-.204 3.89-2.366 4.563-4.744h3.099c-.517 2.93-2.678 5.092-4.215 5.981 1.537.72 3.999 2.606 4.936 6.017h-3.411c-.733-2.282-2.558-4.047-4.972-4.288v4.287h-.372Z" })));
});
